module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "x-button",
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal-header"
  }, [(_vm.mode.add) ? _vm._t("header", [_vm._v("Add an item")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.checkType(_vm.currentWidget.type, 'article') && (_vm.mode.add || _vm.currentWidget.type == 'hero')) ? _vm._t("body", [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "modal-input",
    attrs: {
      "placeholder": "Search Mamamia..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }, _vm.searchForTerm]
    }
  }), _vm._v(" "), (_vm.searchResults) ? _c('div', {
    staticStyle: {
      "font-size": "10px",
      "color": "black",
      "max-height": "45vh",
      "overflow": "auto",
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "searchResults"
    }
  }, _vm._l((_vm.searchResults), function(result, key) {
    return _c('div', {
      key: key,
      class: 'result flex-row ' + (_vm.selectedItem == result ? 'selectedItem' : ''),
      on: {
        "click": [function($event) {
          _vm.selectedItem = result
        }, _vm.onSelected]
      }
    }, [_c('div', [_c('img', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "src": result.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex1"
    }, [_c('h2', {
      domProps: {
        "innerHTML": _vm._s(result.algoliaTitle)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(result.algoliaContent)
      }
    })])])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'podcast')) ? _vm._t("body", [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.podcastPlaylist),
      expression: "podcastPlaylist"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.podcastPlaylist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.podcasts), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": {
          slug: item['.key'],
          title: item.title
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'video')) ? _vm._t("body", [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoPlaylist),
      expression: "videoPlaylist"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.videoPlaylist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.videos), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": {
          slug: item['.key'],
          title: item.title
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'article') && _vm.currentWidget.type !== 'hero') ? _vm._t("body", [_c('modal-multi-article', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "newWidgetOrder": _vm.newWidgetOrder,
      "mode": _vm.mode,
      "storage": _vm.storage
    },
    on: {
      "setWidgetData": function($event) {
        _vm.$emit('setWidgetData', $event)
      },
      "reorder": _vm.reorder
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'author') && _vm.currentWidget.type !== 'hero') ? _vm._t("body", [_c('modal-multi-author', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "newWidgetOrder": _vm.newWidgetOrder,
      "mode": _vm.mode,
      "storage": _vm.storage
    },
    on: {
      "setWidgetData": function($event) {
        _vm.$emit('setWidgetData', $event)
      },
      "reorder": _vm.reorder
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'article') && _vm.currentWidget.type === 'hero') ? _vm._t("body", [_c('modal-single-article', {
    attrs: {
      "storage": _vm.storage,
      "selectedItem": _vm.selectedItem,
      "previewImage": _vm.previewImage,
      "mode": _vm.mode
    },
    model: {
      value: (_vm.previewImage),
      callback: function($$v) {
        _vm.previewImage = $$v
      },
      expression: "previewImage"
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'article')) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.emitArticle
    }
  }, [_vm._v(_vm._s(_vm.mode.edit ? 'Save' : 'Create'))]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'author')) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.updateAuthors
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'podcast')) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('create', _vm.podcastPlaylist)
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'video')) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('create', _vm.videoPlaylist)
      }
    }
  }, [_vm._v("Create")]) : _vm._e()])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fff442c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalCreate.vue
// module id = 640
// module chunks = 1